import dayjs from "dayjs";
import { FilePondFile } from "filepond";
import { Prioridades } from "./PrioridadeSolicitacao";
import { Situacoes } from "./Situacao";
import { SolicitacaoResumida } from "./SolicitacaoResumida";

export interface SolicitacaoDetalhada extends SolicitacaoResumida {
  idCriador?: string,
  descricao?: string
  solucao?: string
}

export interface SolicitacaoDetalhadaCadastroFormulario extends SolicitacaoDetalhada {
  extra?: {
    anexos?: FilePondFile[]
  }
}

export interface SolicitacaoDetalhadaCadastroDTO extends SolicitacaoDetalhada {
  /**
   * Identificadores dos anexos a serem confirmados
   */
  idsAnexos: string[]
}

export const solicitacaoDetalhadaVazia = (): SolicitacaoDetalhada => {
  return {
    id: 0,

    titulo: "",
    descricao: undefined,
    solucao: undefined,
  
    classificacao: undefined,
  
    idSolicitante: undefined,
    idCriador: undefined,
    responsavelTecnico: undefined,

    prioridade: Prioridades.NORMAL,
    situacao: Situacoes.EM_ABERTO,
    unidadeResponsavel: undefined,
    //reino: {id: 1, nome: "Secretaria de Tecnologia da Informação", nomeSistema: "Portal de Serviços da STI", sigla: "STI"}

    dataCriacao: dayjs(),
    dataAtualizacao: undefined
  }
}
